/**
* @Author: zachalam
* @Date:   2017-01-31T10:39:14-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-31T10:39:14-08:00
*/

import * as sdk from '../sdk';
import { storeMeta } from './metaActions';
import { browserHistory } from 'react-router';

export const requestMail = () => {
  return {
    type: 'REQUEST_MAIL'
  }
}

export const clearMail = () => {
  return {
    type: 'CLEAR_MAIL'
  }
}

export const storeMail = (payload) => {
    // store all threads for a user
    return {
      type: 'STORE_MAILLIST',
      payload
    }
}

export const clearConvo = () => {
  return {
    type: 'CLEAR_CONVO'
  }
}

export const requestConvo = () => {
  return {
    type: 'REQUEST_CONVO'
  }
} 

export const storeConvo = (payload) => {
  // store the messages in a thread we are viewing.
  return {
    type: 'STORE_CONVO',
    payload
  }
}

export const storeNewMessage = (payload) => {
  // store new message from user.
  return {
    type: 'STORE_MESSAGE',
    payload
  }
}

export const refreshMail = (type="inbox",firstCall=true,per_page=0) => {
  return(dispatch,getState) => {
    let pageToGet = 0;

    if(firstCall) { dispatch(clearMail()); }
    else { pageToGet = getState().meta.mail_current_page+1; }

    dispatch(requestMail());

    return sdk.getMailList(getState().auth.jwToken,type,pageToGet,per_page)
              .then((response) => {
                // store returned mail in reducer
                dispatch(storeMail(response.data.data));
                // store pagination
                let page = response.data.meta.pagination;
                dispatch(storeMeta({mail_current_page: page.current_page, mail_total_pages: page.total_pages}));

              })
              .catch((error) => {
                // unable to get mail list from server.
                //console.log(error.response);
              });
  }
}


export const refreshConvo = (username) => {
  return(dispatch,getState) => {
    dispatch(clearConvo());
    dispatch(requestConvo());

    return sdk.getMailConvo(getState().auth.jwToken,username)
              .then((response) => {
                // store returned thread for cono (save convo)
                dispatch(storeConvo(response.data.data));
              });
  }
}

export const postMail = (username,message) => {
  return(dispatch,getState) => {
    return sdk.postMailConvo(getState().auth.jwToken,username,message)
              .then((response) => {
                // store returned message data.
                dispatch(storeNewMessage(response.data.data));
              })
  }
}


export const deleteMail = (username) => {
  return(dispatch,getState) => {
    return sdk.deleteMailThread(getState().auth.jwToken,username)
              .then((response) => {
                // redirect user to mail
                browserHistory.push("/mail");
              })
  }
}



// WEBPACK FOOTER //
// ./src/actions/mailActions.js